import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from "@react-google-maps/api";
import iconPR from "../Map/Tarjeta3.png"; // Imagen del marcador

const YOUR_API_KEY = "AIzaSyA9ev-ycCRgJGO3xozQ5alvXmRaaTVsPXI"; // Llave 02 Jul 2024

const mapContainerStyles = {
  width: "100%",
  height: "60vh",
  position: "relative",
  paddingBottom: "3rem",
  paddingTop: "3rem",
  paddingLeft: "5rem",
};

const menuContainerStyles = {
  position: "absolute",
  left: "5rem",
  top: "0.5rem",
  zIndex: 1,
};

const mapStyles = { width: "100%", height: "100%" };
const defaultCenter = { lat: -23.613278, lng: -70.398889 };

const MapComponent = () => {
  const { isLoaded } = useJsApiLoader({ googleMapsApiKey: YOUR_API_KEY });

  const [markers, setMarkers] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(11.7);

  const selectedPlace = selectedIndex !== null ? markers[selectedIndex] : null;

  useEffect(() => {
    const fetchMarkers = async () => {
      try {
        const response = await fetch("/data/markersmap.json");
        if (response.ok) {
          const data = await response.json();
          setMarkers(data);
        }
      } catch (error) {
        console.error("Error fetching markers:", error);
      }
    };
    fetchMarkers();
  }, []);

  const handleMarkerClick = (index) => {
    setSelectedIndex(index);
    setZoomLevel(14);
  };

  const handleCloseInfoWindow = () => setSelectedIndex(null);

  const handleMarkerSelect = (event) => {
    const idx = event.target.value === "" ? null : Number(event.target.value);
    setSelectedIndex(idx);
    if (idx !== null) setZoomLevel(14);
  };

  if (!isLoaded) return <div>Cargando mapa...</div>;

  return (
    <div style={mapContainerStyles}>
      <div style={menuContainerStyles}>
        <select value={selectedIndex ?? ""} onChange={handleMarkerSelect}>
          <option value="">Puntos de recargas</option>
          {markers.map((m, index) => (
            <option key={index} value={index}>
              {m.store} — {m.name}
            </option>
          ))}
        </select>
      </div>

      <GoogleMap
        mapContainerStyle={mapStyles}
        center={selectedPlace ? selectedPlace.position : defaultCenter}
        zoom={zoomLevel}
      >
        {markers.map((marker, index) => (
          <Marker
            key={index}
            position={marker.position}
            onClick={() => handleMarkerClick(index)}
            title={`${marker.store} — ${marker.name}`} // tooltip
            icon={{
              url: iconPR,
              scaledSize: new window.google.maps.Size(40, 40),
            }}
          />
        ))}

        {selectedPlace && (
          <InfoWindow position={selectedPlace.position} onCloseClick={handleCloseInfoWindow}>
            <div style={{ maxWidth: 220 }}>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>{selectedPlace.store}</div>
              <div style={{ opacity: 0.85 }}>{selectedPlace.name}</div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
};

export default MapComponent;
